// NordLight (AYO) landing — light interactions
(function () {
  // Reveal on scroll
  var els = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && els.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  } else {
    els.forEach(function (el) { el.classList.add('is-in'); });
  }

  // Footer year
  var yr = document.getElementById('ft-year');
  if (yr) yr.textContent = new Date().getFullYear();

  // "How it works" tabs (if present)
  document.querySelectorAll('[data-tabs]').forEach(function (group) {
    var tabs = group.querySelectorAll('[data-tab]');
    var panels = group.querySelectorAll('[data-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var name = tab.getAttribute('data-tab');
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === name); });
      });
    });
  });

  // Header: frosted glass over the hero, solid white once scrolled past it
  var header = document.querySelector('.site-header');
  var hero = document.querySelector('.hero');
  if (header && hero && 'IntersectionObserver' in window) {
    var hio = new IntersectionObserver(function (entries) {
      header.classList.toggle('is-solid', !entries[0].isIntersecting);
    }, { rootMargin: '-90px 0px 0px 0px' });
    hio.observe(hero);
  }
})();

// Logo click: on the homepage, smooth-scroll to the very top instead of reloading
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.site-header__logo').forEach(function (logo) {
      logo.addEventListener('click', function (e) {
        if (location.pathname === '/' || location.pathname === '') {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    });
  });
})();


// Mobile nav (audit fix 2026-07-19)
(function () {
  var btn = document.querySelector('[data-mnav-toggle]');
  var nav = document.querySelector('[data-mnav]');
  if (!btn || !nav) return;
  function close() { nav.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
  btn.addEventListener('click', function (e) {
    e.stopPropagation();
    var open = nav.hidden;
    nav.hidden = !open ? true : false;
    if (open) { nav.hidden = false; }
    btn.setAttribute('aria-expanded', String(!nav.hidden));
  });
  document.addEventListener('click', function (e) {
    if (!nav.hidden && !nav.contains(e.target) && e.target !== btn) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  nav.addEventListener('click', function (e) { if (e.target.tagName === 'A') close(); });
})();

// How-section tabs: auto-advance every 3s while idle, with a linear progress
// bar on the active tab. Pauses on hover/touch, stops for good on user click.
// Respects prefers-reduced-motion.
(function () {
  var CYCLE = 3000;
  document.addEventListener('DOMContentLoaded', function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var split = document.querySelector('.how__split[data-tabs]');
    if (!split) return;
    var tabs = Array.prototype.slice.call(split.querySelectorAll('.how__mtab[data-tab]'));
    var panels = split.querySelectorAll('[data-panel]');
    if (tabs.length < 2) return;

    var timer = null, stopped = false, paused = false;

    function bar(tab) {
      var b = tab.querySelector('.how__mtab-progress');
      if (!b) {
        b = document.createElement('span');
        b.className = 'how__mtab-progress';
        tab.appendChild(b);
      }
      return b;
    }

    function resetBars() {
      tabs.forEach(function (t) {
        var b = t.querySelector('.how__mtab-progress');
        if (b) { b.style.transition = 'none'; b.style.width = '0%'; }
      });
    }

    function runBar(tab) {
      var b = bar(tab);
      b.style.transition = 'none';
      b.style.width = '0%';
      void b.offsetWidth; // reflow so the transition restarts
      b.style.transition = 'width ' + CYCLE + 'ms linear';
      b.style.width = '100%';
    }

    function activate(tab) {
      var name = tab.getAttribute('data-tab');
      tabs.forEach(function (t) {
        t.classList.toggle('is-active', t === tab);
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-panel') === name);
      });
    }

    function tick() {
      var current = tabs.findIndex(function (t) { return t.classList.contains('is-active'); });
      var next = tabs[(current + 1) % tabs.length];
      activate(next);
      runBar(next);
    }

    function start() {
      if (stopped || paused || timer) return;
      var active = tabs.find(function (t) { return t.classList.contains('is-active'); }) || tabs[0];
      runBar(active);
      timer = setInterval(tick, CYCLE);
    }

    function halt() {
      if (timer) { clearInterval(timer); timer = null; }
      resetBars();
    }

    // pause while the pointer is over the section, resume when it leaves
    split.addEventListener('pointerenter', function () { paused = true; halt(); });
    split.addEventListener('pointerleave', function () { paused = false; start(); });
    // a real user choice stops the showcase for good
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { stopped = true; halt(); });
    });
    // only run while the section is on screen
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { start(); } else { halt(); }
      }, { threshold: 0.35 });
      io.observe(split);
    } else {
      start();
    }
  });
})();
